const entitySelectorEl = document.querySelector('.js-select-user-activity-entity');
const yearSelectorEl = document.querySelector('.js-select-user-activity-year');
const monthSelectorEl = document.querySelector('.js-select-user-activity-month');
const formEl = document.querySelector("[name='user_activity_filter']");

if (entitySelectorEl) {
    $(entitySelectorEl).select2().on('change', () => {
        formEl.submit();
    });

    $(yearSelectorEl).select2().on('change', () => {
        formEl.submit();
    });

    $(monthSelectorEl).select2().on('change', () => {
        formEl.submit();
    });
}